import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AuPair = () => {
  return (
    <div className="bg-dark min-vh-100">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3 text-light">Au Pair Program</h1>
          <p className="lead text-warning fw-bold">Cultural Exchange Childcare Experience</p>
          <Link to="/klassicare">
            <Button variant="outline-warning" className="mt-3">
              <i className="bi bi-arrow-left me-2"></i>
              Back to KlassiCare
            </Button>
          </Link>
        </div>

        <Row className="g-4 mb-5">
          <Col md={4}>
            <Card className="h-100 bg-dark-subtle border-warning">
              <Card.Body>
                <Card.Title className="text-light h3 mb-3">Live-In Care</Card.Title>
                <Card.Text className="text-primary">
                  Full-time cultural childcare experience in your home.
                  Flexible scheduling with dedicated au pair support.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 bg-dark-subtle border-warning">
              <Card.Body>
                <Card.Title className="text-light h3 mb-3">Language Learning</Card.Title>
                <Card.Text className="text-primary">
                  Natural language immersion for your children.
                  Cultural exchange through daily interaction.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 bg-dark-subtle border-warning">
              <Card.Body>
                <Card.Title className="text-light h3 mb-3">Cultural Exchange</Card.Title>
                <Card.Text className="text-primary">
                  Rich cultural experiences for your family.
                  Global perspectives and international connections.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="g-4">
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Our Au Pairs</h2>
              <ul className="text-primary">
                <li className="mb-2">Carefully selected international candidates</li>
                <li className="mb-2">Extensive childcare experience</li>
                <li className="mb-2">Background checks and references</li>
                <li className="mb-2">Cultural exchange program certified</li>
                <li className="mb-2">Ongoing support and supervision</li>
              </ul>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Program Benefits</h2>
              <p className="text-primary mb-4">
                Experience the advantages of our Au Pair program:
              </p>
              <ul className="text-primary">
                <li className="mb-2">Flexible childcare scheduling</li>
                <li className="mb-2">Language learning opportunities</li>
                <li className="mb-2">Cultural enrichment for your family</li>
                <li className="mb-2">Cost-effective long-term care</li>
                <li className="mb-2">Comprehensive program support</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AuPair; 